export interface OrganizationApiResource {
  code: string;
  name: string;
  type: string;
  status: string;
  business_name: string | null;
  default_language: string;
  legal_name: string | null;
  tax_identifier: string | null;
  registration_number: string | null;
  address_line1: string | null;
  address_line2: string | null;
  postal_code: string | null;
  city: string | null;
  country_code: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  contact_website: string | null;
  client_cancellation_cutoff_hours: number;
  client_record_retention_years: number;
}

export interface Organization {
  code: string;
  name: string;
  type: string;
  status: string;
  businessName: string | null;
  defaultLanguage: string;
  legalName: string | null;
  taxIdentifier: string | null;
  registrationNumber: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  postalCode: string | null;
  city: string | null;
  countryCode: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  contactWebsite: string | null;
  clientCancellationCutoffHours: number;
  clientRecordRetentionYears: number;
}

export interface OrganizationUpdate {
  name: string;
  defaultLanguage: string;
  businessName: string | null;
  legalName: string | null;
  taxIdentifier: string | null;
  registrationNumber: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  postalCode: string | null;
  city: string | null;
  countryCode: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  contactWebsite: string | null;
  clientCancellationCutoffHours: number | null;
  clientRecordRetentionYears: number | null;
}

export function mapApiResourceToOrganization(resource: OrganizationApiResource): Organization {
  return {
    code: resource.code,
    name: resource.name,
    type: resource.type,
    status: resource.status,
    businessName: resource.business_name,
    defaultLanguage: resource.default_language,
    legalName: resource.legal_name,
    taxIdentifier: resource.tax_identifier,
    registrationNumber: resource.registration_number,
    addressLine1: resource.address_line1,
    addressLine2: resource.address_line2,
    postalCode: resource.postal_code,
    city: resource.city,
    countryCode: resource.country_code,
    contactEmail: resource.contact_email,
    contactPhone: resource.contact_phone,
    contactWebsite: resource.contact_website,
    clientCancellationCutoffHours: resource.client_cancellation_cutoff_hours,
    clientRecordRetentionYears: resource.client_record_retention_years,
  };
}

export function mapOrganizationUpdateToPayload(
  update: OrganizationUpdate
): Record<string, string | number | null> {
  return {
    name: update.name,
    default_language: update.defaultLanguage,
    business_name: update.businessName,
    legal_name: update.legalName,
    tax_identifier: update.taxIdentifier,
    registration_number: update.registrationNumber,
    address_line1: update.addressLine1,
    address_line2: update.addressLine2,
    postal_code: update.postalCode,
    city: update.city,
    country_code: update.countryCode,
    contact_email: update.contactEmail,
    contact_phone: update.contactPhone,
    contact_website: update.contactWebsite,
    client_cancellation_cutoff_hours: update.clientCancellationCutoffHours,
    client_record_retention_years: update.clientRecordRetentionYears,
  };
}
